import { USER_LOGOUT } from '@/store/actions.type'
import { mapActions, mapGetters } from 'vuex'

export default {
    data () {
        return {
            isLoggedin: false
        }
    },
    created () {
        this.checkauth()
    },

    computed: {
        userData () {
            return this.$store.state.authentication.user
        },
        isRedirectedBrokerUrl(){
            return (localStorage.getItem('utmParams')==undefined || localStorage.getItem('utmParams')==null )?false:true;
        }
    },

    methods: {

        ...mapActions({
            userlogout: USER_LOGOUT,
        }),

        async logout () {
            var self = this;
            localStorage.removeItem("utmParams")
            await this.userlogout().then(data => {
                self.$store.commit('LOGOUT_USER');
                self.$router.replace('/');
                window.location.reload();
            });
        },

        async checkauth () {
            if (localStorage.getItem('psitoken')) {
                this.isLoggedin = true;
            }
            else {
                this.isLoggedin = false;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/more.js